import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import qs from "query-string";

import ShPageModel from "../../../components/ShPageModel";
import PageHeader from "../../../components/PageHeader";

import { UserContext } from "../../../context";
import { STATUS } from "../../../constants";

import { reqCopyRightsList } from "../../../service/query/copyright";
import { reqAxioscopyrightsLists } from "../../../api/lists";
export default function Patents() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(STATUS.idle);
  const [copyRightsList, setCopyRightsList] = useState([]);
  const [aprSort, setAprSort] = useState("");
  const [total, setTotal] = useState(1);
  const location = useLocation();
  const { parkId } = useContext(UserContext);
  const handleStatus = (status) => {
    setStatus(status);
  };
  const [query, setQuery] = useState({});

  // 声明一个状态变量用于保存选中的行
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // 声明一个状态变量用于保存 id_cp 的数组
  const [idCps, setIdCps] = useState([]);

  // 当复选框状态改变时触发
  const onSelectChange = (newSelectedRowKeys, selectedRows, dataSource, rowKey) => {
    // console.log(`selectedRowKeys: ${newSelectedRowKeys}`, 'selectedRows: ', selectedRows);

    // 获取当前页面的选中行的 id_cp
    const newIdCps = selectedRows.map(row => row.id_cp);

    // 从数据源中提取出每一项的行键（默认为 'id'），生成当前页面所有行的键数组
    const currentPageKeys = dataSource.map(item => item[rowKey ?? 'id']);

    // 更新选中的行键数组：
    // 1. 保留当前选中行键中那些在当前页面中的行键，并且这些行键仍然被新选中的行键包含。
    // 2. 保留当前选中行键中那些不在当前页面中的行键（这些行键不会被新选中的行键影响）。
    const updatedSelectedRowKeys = selectedRowKeys.filter(key =>
      currentPageKeys.includes(key) ? newSelectedRowKeys.includes(key) : true
    );

    // 更新选中的 id_cp 数组：
    // 1. 保留当前选中 id_cp 中那些在当前页面中的 id_cp，并且这些 id_cp 仍然被新选中的行数据包含。
    // 2. 保留当前选中 id_cp 中那些不在当前页面中的 id_cp（这些 id_cp 不会被新选中的行数据影响）。
    const updatedIdCps = idCps.filter(cp =>
      currentPageKeys.includes(dataSource.find(item => item.id_cp === cp)?.[rowKey ?? 'id']) ? newIdCps.includes(cp) : true
    );

    // 遍历新选中的行键数组，将不在 updatedSelectedRowKeys 中的行键添加进去
    newSelectedRowKeys.forEach(key => {
      if (!updatedSelectedRowKeys.includes(key)) {
        updatedSelectedRowKeys.push(key);
      }
    });

    // 遍历新选中的 id_cp 数组，将不在 updatedIdCps 中的 id_cp 添加进去
    newIdCps.forEach(cp => {
      if (!updatedIdCps.includes(cp)) {
        updatedIdCps.push(cp);
      }
    });

    // 更新状态
    setSelectedRowKeys(updatedSelectedRowKeys);
    setIdCps(updatedIdCps);
  };

  // 表格行选择配置
  const rowSelection = {
    selectedRowKeys,  // 当前选中的行键数组
    // 当行选择变化时，调用 onSelectChange 函数，并传递新选中的行键、新选中的行数据、当前页面的数据源和行键字段（默认为 'id'）
    onChange: (newSelectedRowKeys, selectedRows) => onSelectChange(newSelectedRowKeys, selectedRows, copyRightsList, 'id'),
  };

  // 清空复选框选中状态
  const resetSelection = () => {
    // 清空复选框选中状态
    setSelectedRowKeys([]);
    // 清空 id_cp 数组
    setIdCps([]);
  };

  // 表格发生变化时出发的函数，传递给form组件的change
  // 切换升降序时，修改url中有关排序的参数
  const handleTableChange = (pagination, filters, sorter) => {
    const newQuery = {
      // query 在 useEffect中已经被替换为新的值
      ...query,
      sortFiled: sorter.field,
      sortOrder: sorter.order,
    };
    let newUrl = `?${Object.entries(newQuery)
      .map(([key, value]) => `${key}=${value ?? ""}`)
      .join("&")}`;
    navigate(newUrl);
  };

  const copyrightsTableConfig = {
    nameList: [
      {
        title: "类型",
        render: () => (
          <img
            style={{
              display: "block",
              width: "3rem",
              height: " 3rem",
            }}
            src="/icon/ico-copyright-1.png"
            alt="专利类型"
          />
        ),
      },
      {
        title: "类别",
        dataIndex: "type_name",
      },
      {
        title: "著作权名称",
        dataIndex: "name",
      },

      {
        title: "登记号",
        dataIndex: "number",
      },
      // {
      //   title: "作品分类",
      //   dataIndex: "type",
      // },
      {
        title: "创作时间",
        dataIndex: "success_date",
      },
      {
        title: "发布时间",
        dataIndex: "first_date",
      },
      {
        title: "登记人",
        dataIndex: "company",
      },
      {
        title: "登记时间",
        dataIndex: "approval_date",
        sorter: true,
        sortOrder: aprSort,
      },
    ],
  };
  useEffect(() => {
    const parsedQuery = qs.parse(location.search.slice(1), {
      parseNumbers: true,
    });
    setAprSort(
      parsedQuery.sortFiled === "approval_date" ? parsedQuery.sortOrder : ""
    );
    setQuery(parsedQuery);

    if (parkId) {
      const doPost = () => {
        reqCopyRightsList(parsedQuery, parkId).then((res) => {
          setCopyRightsList(res.data);
          setTotal(res.count);
          setStatus(STATUS.success);
        });
      };
      if (status === STATUS.idle) {
        doPost();
      }
    }
  }, [location, total, parkId, status]);

  useEffect(() => {
    setStatus(STATUS.idle);
  }, [parkId, location]);
  return (
    <>
      <PageHeader
        title="著作权数据检索"
        description="检索入驻园区企业的相关著作权信息。"
      />

      <ShPageModel
        placeholder="著作权名称/登记号"
        changeStatus={handleStatus}
        status={status}
        config={copyrightsTableConfig}
        dataSource={copyRightsList}
        total={total}
        reqExport={reqAxioscopyrightsLists}
        handleTableChange={handleTableChange}
        rowSelection={rowSelection} // 复选框: 传递 rowSelection 属性
        idCps={idCps} // 传递 idCps
        resetSelection={resetSelection} // 清空复选框: 传递 resetSelection 属性
      />
    </>
  );
}
